function Footer() {
  return (
    <footer className="footer">
      <div className="footer-links">
        <a href="#/privacy" className="footer-link">
          Privacy Policy
        </a>
        <a href="#/terms" className="footer-link">
          Terms of Service
        </a>
        <a href="#/legal" className="footer-link">
          Site Notice
        </a>
        <a href="#/about" className="footer-link">
          About Us
        </a>
        <a href="#/contact" className="footer-link">
          Contact Us
        </a>
      </div>
      <div className="footer-text">© 2025 PartySpark Hub</div>
    </footer>
  );
}

export default Footer;

